import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TranslationService {
    constructor(private http: HttpClient) {}

    public getTranslation(language: string): Observable<any> {
        const translationFile: string = `assets/i18n/${language}.json`;
        
        return this.http.get<any>(translationFile);
    }
}
